import React from "react";
import createClass from "create-react-class";

const DownloadButton = createClass({
  render() {
    return (
      <a className="btn-link" href="/driver-app">
        <div className="DownloadButton">
          <div className="btn">دریافت اسنپ رانندگان</div>
        </div>
      </a>
    );
  }
});

module.exports = DownloadButton;



// WEBPACK FOOTER //
// ./src/js/components/common/DownloadButton.react.js